import { render, staticRenderFns } from "./ViewCustomerAddresses.vue?vue&type=template&id=f6f92436&scoped=true&"
import script from "./ViewCustomerAddresses.vue?vue&type=script&lang=js&"
export * from "./ViewCustomerAddresses.vue?vue&type=script&lang=js&"
import style0 from "./ViewCustomerAddresses.vue?vue&type=style&index=0&id=f6f92436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f92436",
  null
  
)

export default component.exports